module.exports = __webpack_public_path__ + "static/media/newelectricbike.739d4ef2.jpg";